// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { environment } from '../../environments/environment';

// @Injectable()
// export class MissingCapabilityService {

//     constructor(
//         private _http: HttpClient
//     ) { }


// }

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class MissingCapabilityService {

    isShowing: boolean = false;
    modal = new Subject<boolean>();

    constructor() {
        this.modal.subscribe((value) => {
            this.isShowing = value;
        });
    }

    // getModal() {
    //     return this.modal;
    // }
    open() {
        // this.isShowing = true;
        this.modal.next(true);
    }
    close() {
        // this.isShowing = false;
        this.modal.next(false);
    }


}



// WEBPACK FOOTER //
// ./src/app/missing-capability/missing-capability.service.ts